import { useEffect, useState } from "react";

export default function AdbCarousel({ items, imagesDir = "google_logout" }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const total = items.length;
  const current = items[Math.min(activeIndex, total - 1)];
  const preferredSrc = `${process.env.PUBLIC_URL}/images/steps/${imagesDir}/${current.image_reference || `${current.step_id}.jpg`}`;
  const fallbackSrc = `${process.env.PUBLIC_URL}/images/steps/${imagesDir}/${current.step_id}.jpg`;
  const [imgSrc, setImgSrc] = useState(preferredSrc);

  useEffect(() => {
    setImgSrc(preferredSrc);
  }, [preferredSrc]);

  const goPrev = () => setActiveIndex((i) => (i - 1 + total) % total);
  const goNext = () => setActiveIndex((i) => (i + 1) % total);

  return (
    <div className="adb-carousel">
      <div className="adb-carousel-top">
        <div className="adb-carousel-counter" aria-live="polite">
          Étape {activeIndex + 1} / {total}
        </div>
        <div className="adb-carousel-steps">{current.category}</div>
      </div>

      <div className="adb-carousel-figure">
        <button
          type="button"
          className="adb-carousel-nav"
          onClick={goPrev}
          aria-label="Image précédente"
        >
          ‹
        </button>

        <img
          className="adb-carousel-image"
          src={imgSrc}
          alt={current.title}
          onError={() => setImgSrc(fallbackSrc)}
        />

        <button
          type="button"
          className="adb-carousel-nav"
          onClick={goNext}
          aria-label="Image suivante"
        >
          ›
        </button>
      </div>

      <div
        className="adb-carousel-dots"
        role="tablist"
        aria-label="Navigation carrousel"
      >
        {items.map((it, idx) => (
          <button
            key={it.step_id}
            type="button"
            className={`adb-carousel-dot ${idx === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(idx)}
            aria-label={`Aller à l'image ${idx + 1}`}
            aria-selected={idx === activeIndex}
            role="tab"
          />
        ))}
      </div>

      <div className="adb-carousel-text">
        <h3 className="adb-carousel-title">{current.title}</h3>
        <p className="adb-carousel-instruction">{current.instruction}</p>
        <p className="adb-carousel-target">
          <span className="adb-carousel-target-label">À appuyer :</span>{" "}
          {current.target_element}
        </p>
        {current.download && (
          <div className="download-action">
            {current.isExternal ? (
              <a
                href={current.download}
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn"
              >
                <span className="btn-icon">📥</span>
                Télécharger {current.download.split("/").pop()}
              </a>
            ) : (
              <a
                href={`/others/${current.download}`}
                download={current.download}
                className="download-btn"
              >
                <span className="btn-icon">📥</span>
                Télécharger {current.download}
              </a>
            )}
          </div>
        )}
        {current.skip_to && (
          <div className="skip-action">
            <button
              type="button"
              className="skip-btn"
              onClick={() =>
                setActiveIndex(
                  items.findIndex((it) => it.step_id === current.skip_to),
                )
              }
            >
              Passer à l'étape {current.skip_to} ↪
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
